<template>
  <div v-if="visible" class="loading-overlay">
    <div class="loading-content">
      <b-spinner :variant="variant" label="Loading..."></b-spinner>
      <p class="mt-2 mb-0">{{ message }}</p>
    </div>
  </div>
</template>

<script>
import { BSpinner } from "bootstrap-vue";

export default {
  name: "LoadingOverlay",
  components: {
    BSpinner,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "Loading...",
    },
    variant: {
      type: String,
      default: "primary",
    },
  },
};
</script>

<style lang="scss" scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.loading-content {
  text-align: center;
}
</style>
